import 'antd/lib/switch/style';
//# sourceMappingURL=index.js.map